import { setAiContext } from '@/redux/actions/uiActions/setAiContext';
import selectors from '@/redux/selectors/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const AiContextHandler = () => {
  const pathname = useSelector(selectors.pathname);

  useEffect(() => {
    const context = {
      currentPath: pathname,
      timestamp: new Date().toISOString()
    };

    setAiContext(context);
  }, [pathname]);

  return null;
};

export default AiContextHandler;
